import {FC} from 'react'
import CsvDownloader from 'react-csv-downloader'
import {ExportCsvProps} from '../types'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import moment from 'moment'

const Button: FC<{disabled?: boolean}> = ({disabled}) => {
  return (
    <OverlayTrigger overlay={<Tooltip id='export-csv-tooltip'>Download CSV</Tooltip>}>
      <button
        type='button'
        className='btn btn-sm btn-icon btn-light-success m-1'
        disabled={disabled}
      >
        <i className='fa fa-file-csv' />
      </button>
    </OverlayTrigger>
  )
}

const ExportCsv: FC<ExportCsvProps> = ({columns, data, filename, title}) => {
  if (data?.length === 0) return <Button disabled />

  const columnHeadings: any[] = []
  for (const column of columns) {
    if (column.field === 'action' || column.hideInCSV) continue
    columnHeadings.push({
      id: column.field,
      displayName: column.name,
    })
  }

  const rows: any[] = []
  for (let idx = 0; idx < data.length; idx++) {
    const row = data[idx]
    const object: any = {}

    for (let idx = 0; idx < columnHeadings.length; idx++) {
      const columnHeading = columnHeadings[idx]
      const key = columnHeading.id
      const column = columns.find((c) => c.field === key)

      if (!column) {
        continue
      }

      if (typeof column?.getText === 'function') {
        object[key] = column.getText(row)
      } else if (column?.type === 'date') {
        object[key] = moment(row[key]).isValid()
          ? moment(row[key]).format(
              ['h', 'm', 's', 'k', 'lll', 'lt', 'lts'].some((k) =>
                column.dateFormat?.toLocaleLowerCase()?.includes(k)
              )
                ? 'YYYY-MM-DD HH:mm:ss'
                : 'YYYY-MM-DD'
            )
          : ''
      } else {
        object[key] = row[key]
      }
    }

    rows.push(object)
  }

  return (
    <CsvDownloader title={title} filename={filename} columns={columnHeadings} datas={rows} suffix>
      <Button />
    </CsvDownloader>
  )
}

export default ExportCsv
